// Image URL comes from .env.development / .env.production / build:dev script.
// Fallback is dev so a misconfigured build never accidentally hits prod.
//
// PROD sets this to EMPTY (hence ?? not ||): image paths are stored as
// "/upload/..." and resolve same-origin, where nginx aliases /upload/ to
// the API's files. Cross-origin <img> loads get silently killed by the
// privacy/ad-block extensions some admins run (found 2026-08-17 — the
// bytes arrived, the render was vetoed); same-origin is immune.
const IMG_URL = process.env.REACT_APP_IMG_URL ?? "https://devapitreatwalk.equitysoft.tech";

export const ApiList = {
    IMG_URL,
    //AUTH
    LOGIN:"auth/login",
    FORGOT_PASSWORD:"auth/forget-password",
    USER_GET:"base/get",
    GET_STRIKE:"streak/get-restore-requests",
    APPROVE_REJECT_STRIKE:"streak/approve-reject-restore-request",
    GENERAL_DOCS_UPDATE:"/base/up/general_docs/1",
    BLOCK_USER:"/user/block-unblock-user",
    GET_REPORTED_USERS:"/user/get-report-users",
    SEND_NOTIFICATION:"notification/send",
    EDIT_NOTIFICATION:"base/up/admin_notification",
    DASHBOARD_TOTAL_COUNTS:"/user/dashboard",
    ADMIN_PULSE:"admin/pulse",                // rolling 24h vs same window -7d (role=2)
    ADMIN_NORTHSTAR:"admin/northstar",       // habit-activated NSM (role=2)
    ADMIN_PREMIUM_GRANT:"admin/premium/grant",   // influencer comp: {user_id, days} (role=2)
    ADMIN_PREMIUM_REVOKE:"admin/premium/revoke", // floor comp expiry + clear RC promotionals
    // METRICS (admin only — role=2)
    METRICS_WALKS:"admin/metrics/walks",      // ?weeks=13
    METRICS_PAYWALL:"admin/metrics/paywall",  // ?weeks=13
    GET_WALK_ISSUES:"admin/walk-issues",      // ?count=&search= (admin only — role=2)
    ADMIN_COSMETICS:"admin/cosmetics",        // Tiwi Closet Manager (role=2; /:id, /:id/images, /:id/status)
    METRICS_FUNNEL:"admin/metrics/funnel",             // ?days=0|30|90
    METRICS_FUNNEL_USERS:"admin/metrics/funnel/users", // ?stage=registered&days=0
    //HASHTAG
    HASHTAG_CREATE:"base/in/tags",
    HASHTAG_UPDATE:"base/up/tags",
    HASHTAG_DELETE:"base/up/tags",
    FEEDBACKS:"user/get-survey-list",
    PREMIUM_USERS:"admin/premium-users",      // full roster, admin only — role=2
    DIG_METRICS:"admin/dig-metrics",          // Doggo & Daily Dig usage rollups — role=2
    REFERRAL_CODES:"admin/referrals/codes",   // per-code usage + referee premium rollup — role=2
    REFERRAL_CODE_REFEREES:(codeId) => `admin/referrals/codes/${codeId}/referees`,
    GET_FAQS:"admin/get-faqs",
    ADD_FAQ:"admin/add-faqs",
    EDIT_FAQ:"admin/edit-faqs",
    DELETE_FAQ:"admin/delete-faq",
    GET_COMMENT_REASONS:"base/get",
    ADD_COMMENT_REASON:"base/in/comment_report_reasons",
    EDIT_COMMENT_REASON:"base/up/comment_report_reasons",
    DELETE_COMMENT_REASON:"base/up/comment_report_reasons",
    GET_REPORTED_COMMENTS:"base/get",
    // SPOTS (Phase 2 admin moderation)
    SPOT_ADMIN_LIST:"spot/admin/list",
    SPOT_ADMIN_DETAIL:"spot/admin",           // append /:id
    SPOT_ADMIN_APPROVE:"spot/admin",          // append /:id/approve (POST)
    SPOT_ADMIN_REJECT:"spot/admin",           // append /:id/reject (POST body: { reason })
    SPOT_ADMIN_EDIT:"spot/admin",             // append /:id (PATCH)
    SPOT_ADMIN_ARCHIVE:"spot/admin",          // append /:id/archive (POST)
    SPOT_ADMIN_TAGS:"spot/admin/tags",        // GET list, POST create
    SPOT_ADMIN_TAG:"spot/admin/tags",         // append /:id (PATCH)
    SPOT_ADMIN_TAG_ARCHIVE:"spot/admin/tags", // append /:id/archive (POST)
    SPOT_ADMIN_PHOTO:"spot/admin",            // append /:id/photo (POST multipart) | /:id/photo/:photoId/primary (POST) | /:id/promote-review-photo/:reviewPhotoId (POST)
    ADMIN_EVENTS:"admin/events",              // Events manager (role=2; /:id, /:id/status)
    ADMIN_BADGES:"admin/badges",              // GET list, POST create | append /:id (POST update) | /:id/image (POST multipart) | /:id/status (POST)
}
